import Form from "react-bootstrap/Form";
import React, {useContext} from "react";
import {UnitsContext} from "../../index";
import {dateFormat, formatDate, parseDate} from "../../util/time";
import DayPickerInput from "react-day-picker/DayPickerInput";
import {getDictionaries, setDictionaries} from "../../storage/user";
import CreatableSelect from "react-select/creatable/dist/react-select.esm";
import Select from "react-select";

function InputWrapper(props) {
    return (
        <>
            <p className="skyduck-color input-label mb-0">
                {props.field.description.label.label}
                {props.field.description.label.append ? <span> ({props.field.description.label.append})</span> : null}
            </p>


            {props.children}

            {props.field.description.validation
                ? <p className={!props.field.touched || (props.field.valid && props.field.touched) ? "display-none" : "my-invalid-feedback"}>
                    {props.field.description.validation.text}
                </p>
                : null
            }

            {props.field.description.prompt
                ? <p className={!props.field.touched || (!props.field.prompt && props.field.touched) ? "display-none" : "my-prompt-feedback"}>
                    {props.field.description.prompt.text}
                </p>
                : null
            }

            <hr className="mt-2 mb-2"/>
        </>
    );
}

export function ReadOnlyText(props) {
    return (
        <>
            {
                props.field.value
                    ? <InputWrapper {...props}>
                            <Form.Control className="input-no-border"
                                          value={props.field.valueToDisplay ? props.field.valueToDisplay : props.field.value}
                                          readOnly
                            />
                    </InputWrapper>
                    : null
            }
        </>
    );
}

export function TextInput(props) {
    return (
        <InputWrapper {...props}>
            <Form.Control
                autoFocus={props.focus}
                onChange={(event) => props.handleFormChange(props.index, props.field, event.target.value)}
                name={props.field.description.name}
                type="text"
                value={props.field.value}
                placeholder={props.field.description.label.placeholder}
                className="input-no-border"
                autocomplete="off"
            />
        </InputWrapper>
    );
}

export function DateInput(props) {
    const units = useContext(UnitsContext).units;
    const FORMAT = dateFormat(units);

    return (
        <InputWrapper {...props}>
            <div className="customDatePickerWidth">
                <DayPickerInput
                    onDayChange={
                        (date) => {
                            if (date instanceof Date) {
                                props.handleFormChange(props.index, props.field, date.getTime() / 1000)
                            }
                        }
                    }
                    value={props.field.value}
                    format={FORMAT}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    placeholder={props.field.description.label.placeholder}
                />
            </div>
        </InputWrapper>
    );
}

export function SelectInput(props) {
    const customStyles = {
        control: (base) => ({
            ...base,
            border: "0",
            borderRadius: "0",
            height: '21px',
            'min-height': '21px',
            'font-size': '.875rem',
            boxShadow: "0"
        }),
        option: (base) => ({
            ...base,
            'font-size': '.875rem',
        }),
        input: (base) => ({
           ...base,
           margin: "0",
           paddingTop: "0",
           paddingBottom: "0",
        }),
        singleValue: (base) => ({
            ...base,
            marginLeft: "0",
            marginRight: "0",
            height: "20px",
            color: "#4a5056"
        }),
        valueContainer: (base) => ({
            ...base,
            height: '20px',
            marginLeft: "0",
            marginRight: "0",
            'min-height': '20px',
            padding: "0"
        }),
        indicatorSeparator: (base) => ({
            display: 'none',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            height: '20px',
            'min-height': '20px',
            padding: '0px 8px'
        }),
        placeholder: (base) => ({
            ...base,
            marginLeft: "0",
            marginRight: "0",
            color: "#6e757c"
        })
    };

    const handleCreate = (index, field, inputValue, creatableCollection) => {
        let dictionaries = getDictionaries();

        dictionaries[creatableCollection].push({
            value: inputValue,
            label: inputValue
        });

        setDictionaries(dictionaries);
        props.updateDictionaries();

        props.handleFormChange(index, field, inputValue);
    };

    return (
        <InputWrapper {...props}>
            <>
                {props.creatableCollection
                    ? <CreatableSelect options={props.options}
                                       name={props.field.description.name}
                                       placeholder={props.field.description.label.placeholder}
                                       styles={customStyles}
                                       value={
                                           props.valueById
                                               ? props.options.filter(option => option.value === props.field.value)
                                               : props.options.filter(option => option.label === props.field.value)
                                       }
                                       onChange={(event) => {
                                           props.valueById
                                               ? props.handleFormChange(props.index, props.field, event.value, event.label)
                                               : props.handleFormChange(props.index, props.field, event.value)
                                       }
                                       }
                                       onCreateOption={(inputValue) => handleCreate(props.index, props.field, inputValue, props.creatableCollection)}
                    />
                    : <Select options={props.options}
                              name={props.field.description.name}
                              placeholder={props.field.description.label.placeholder}
                              styles={customStyles}
                              value={
                                  props.valueById
                                      ? props.options.filter(option => option.value === props.field.value)
                                      : props.options.filter(option => option.label === props.field.value)
                              }
                              onChange={(event) => {
                                  props.valueById
                                      ? props.handleFormChange(props.index, props.field, event.value, event.label)
                                      : props.handleFormChange(props.index, props.field, event.value)
                              }
                              }
                    />}
            </>
        </InputWrapper>
    );
}